import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, RequestConnection, Result } from "../../../../interfaces";
import { loadData } from "../../../connection";

export const FETCH_DATA_SENDED_REQUEST = 'FETCH_DATA_SENDED_REQUEST';
export const FETCH_DATA_SENDED_SUCCESS = 'FETCH_DATA_SENDED_SUCCESS';
export const FETCH_DATA_SENDED_FAILURE = 'FETCH_DATA_SENDED_FAILURE';

const mapConnections = (data: any[]) => {
    const items: RequestConnection[] = [];
  
    data.map((e: any) => {
      const item: RequestConnection = {
        id: e.id,
        content : e.content,
        owner : e.owner,
        from: e.user_created.first_name,
        type: e.user_created.role.name,
        status: e.request_status,
        to: e.organization_name
      }
  
      items.push(item);
    });
  
    return items;
  }
  
  
interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchSendedDataRequest = () => {
    return {
        type: FETCH_DATA_SENDED_REQUEST,
    };
};

const fetchSendedDataSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_SENDED_SUCCESS,
        payload: data
    };
};

const fetchSendedDataFailure = (error: any) => {
    return {
        type: FETCH_DATA_SENDED_FAILURE,
        payload: error,
    };
};

export const getSended = (collection:string, query:Query, page:number, limit:number) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchSendedDataRequest());
        try {
            const response = await loadData(collection || 'connection_request', query, page, limit);
            dispatch(fetchSendedDataSuccess(
                {
                    values: mapConnections(response.data),
                    loading: false,
                    pagination: { limit, page, total: response.meta.total  || response.meta.filter_count}
                }
            ));
        } catch (error: any) {
            dispatch(fetchSendedDataFailure(error.message));
        }
    };
};
